import { Injectable } from "@angular/core";
import { CoreHttpClient } from "@obg/ngx.core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";

import { AwsLocationModel } from "../aws-location/aws-location.model";
import { GeofencingConfigService } from "../geofencing.config";
import { IpLocationResponse } from "../geofencing.model";

@Injectable({ providedIn: "root" })
export class AwsLocationService {
	constructor(
		private config: GeofencingConfigService,
		private httpClient: CoreHttpClient
	) {}

	getGpsLocationAdministrativeArea(lat: number, lon: number): Observable<string | undefined> {
		return this.httpClient
			.get<AwsLocationModel>({
				url: `${this.config.getAwsLocationServiceEndpoint()}?c=${lat},${lon}`,
				withCredentials: false,
			})
			.pipe(map((response) => response?.gpsLocation?.AdministrativeArea));
	}

	getIpLocationCountry(): Observable<IpLocationResponse | undefined> {
		return this.httpClient
			.get<AwsLocationModel>({
				url: this.config.getAwsLocationServiceEndpoint(),
				withCredentials: false,
			})
			.pipe(
				map((response) => ({
					country: response?.ipLocation?.Country,
					state: response?.ipLocation?.AdministrativeArea,
				}))
			);
	}
}
